import formatApiError from '@v/util/formatApiError.js'
import { pipe, propEq, filter, isEmpty, map } from 'ramda'

export function validateBookingProducts(apiClient) {
  return async upsertModel => {
    const bookingKey = upsertModel.booking?.Key
    const validateCall = () =>
      apiClient.post('booking/product/validate', {
        bookingKey: bookingKey,
        bookingProducts: upsertModel.bookingProducts,
      })
    try {
      const response = await validateCall()

      return formatResponse(response.data)
    } catch (e) {
      return formatApiError(e, 'Could not validate booking products')
    }
  }
}

const formatResponse = response => {
  return {
    isValid: isValid(response),
    response: response,
  }
}

const isValid = pipe(
  map(propEq('Errors', [])),
  filter(v => v === false),
  isEmpty,
)
